import Route from '@core/components/Route';
import { styled } from '@mui/material/styles';

export const StyledRouteButton = styled(Route)`
  height: 40px;
  min-width: 240px;
  padding: 0 1.25rem;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  border-radius: 1.5rem;
  margin-top: 1rem;
  text-transform: uppercase;

  &:hover {
    box-shadow: 0 0 10px var(--dark3);
  }
  &:after {
    display: none;
  }

  ${props => props.theme.breakpoints.up('xs')} {
    width: 100%;
  }

  ${props => props.theme.breakpoints.up('md')} {
    width: auto;
  }
`;
